import { render, staticRenderFns } from "./accountsReceivableDashboard.vue?vue&type=template&id=7801c463&scoped=true"
import script from "./accountsReceivableDashboard.vue?vue&type=script&lang=js"
export * from "./accountsReceivableDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7801c463",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7801c463')) {
      api.createRecord('7801c463', component.options)
    } else {
      api.reload('7801c463', component.options)
    }
    module.hot.accept("./accountsReceivableDashboard.vue?vue&type=template&id=7801c463&scoped=true", function () {
      api.rerender('7801c463', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/bulletinBoard/accountsReceivableDashboard.vue"
export default component.exports